import axios from 'axios';
import QueueLag from './queue-lag.entity';

export default class QueueLagService {
  static getVstsLag(): Promise<QueueLag[]> {
    return axios
      .get('/vsts/internal/kafka/lag')
      .then((response: any) => response.data.map((it: any) => new QueueLag(it)));
  }

  static getWorkitemLag(): Promise<QueueLag[]> {
    return axios
      .get('/workitems/internal/kafka/lag')
      .then((response: any) => response.data.map((it: any) => new QueueLag(it)));
  }

  static getTaskLag(): Promise<QueueLag[]> {
    return axios
      .get('/tasks/internal/kafka/lag')
      .then((response: any) => response.data.map((it: any) => new QueueLag(it)));
  }
}
